/**
 * Application theme provider with dark mode + retro mode support
 */

import { ThemeProvider } from '@mui/material/styles';
import { useMemo } from 'react';
import { createAppTheme } from '@/theme/mui-theme';
import { useThemeMode } from '@/hooks/useThemeMode';
import { ThemeContext } from '@/contexts/ThemeContext';

interface AppThemeProviderProps {
  children: React.ReactNode;
}

export function AppThemeProvider({ children }: AppThemeProviderProps) {
  const { mode, appMode, isRetro, toggleMode, setMode, setRetro } = useThemeMode();

  const theme = useMemo(() => createAppTheme(appMode), [appMode]);

  const themeContextValue = useMemo(
    () => ({
      mode,
      appMode,
      toggleMode,
      setMode,
      setRetro,
      isRetro,
    }),
    [mode, appMode, toggleMode, setMode, setRetro, isRetro],
  );

  return (
    <ThemeContext.Provider value={themeContextValue}>
      <ThemeProvider theme={theme}>
        <div suppressHydrationWarning>
          {children}
        </div>
      </ThemeProvider>
    </ThemeContext.Provider>
  );
}
